import { render, staticRenderFns } from "./PageOpportunityAnalysis.vue?vue&type=template&id=4c25ffc0"
import script from "./PageOpportunityAnalysis.vue?vue&type=script&lang=js"
export * from "./PageOpportunityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityAnalysis.vue?vue&type=style&index=0&id=4c25ffc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports